import { __module as e } from "../../../_virtual/rtrim.js";
import { a as r } from "./util/assertString.js";
Object.defineProperty(t = e.exports, "__esModule", {
  value: !0
}), t.default = function (e, r) {
  if ((0, a.default)(e), r) {
    var t = RegExp("[".concat(r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+$"), "g");
    return e.replace(t, "");
  }
  for (var o = e.length - 1; /\s/.test(e.charAt(o));) o -= 1;
  return e.slice(0, o + 1);
}, a = r && r.__esModule ? r : {
  default: r
}, e.exports = t.default, e.exports.default = t.default;
var t,
  a,
  o = e.exports;
export { o as r };